export const GET_PENDING_RECHARGE_REQUESTS_REQUEST = "GET_PENDING_RECHARGE_REQUESTS_REQUEST";
export const GET_PENDING_RECHARGE_REQUESTS_SUCCESS = "GET_PENDING_RECHARGE_REQUESTS_SUCCESS";
export const GET_PENDING_RECHARGE_REQUESTS_FAILURE = "GET_PENDING_RECHARGE_REQUESTS_FAILURE";
export const GET_PENDING_RECHARGE_REQUESTS_RESET = "GET_PENDING_RECHARGE_REQUESTS_RESET";
export const getPendingRechargeRequestsRequest = (payload) => ({
    type: GET_PENDING_RECHARGE_REQUESTS_REQUEST,
    payload,
});
export const getPendingRechargeRequestsSuccess = (payload) => ({
    type: GET_PENDING_RECHARGE_REQUESTS_SUCCESS,
    payload,
});
export const getPendingRechargeRequestsFailure = (payload) => ({
    type: GET_PENDING_RECHARGE_REQUESTS_FAILURE,
    payload,
});
export const getPendingRechargeRequestsReset = () => ({
    type: GET_PENDING_RECHARGE_REQUESTS_RESET,
});
